import React, { useState } from "react";
import { FormElement, FormLabel, FormInput, FormSelector, ItalicSubTitle } from "../StyledElements";
import { Dialog } from "../Dialog";
import { queryDataSet } from "../../services/data";

export const QueryDialog = ({ dataSet, show, onClose }) => {
  const [query, setQuery] = useState("");
  const [queryType, setQueryType] = useState("similarity");

  const handleQuery = async () => {
    const results = await queryDataSet(dataSet.public_id, query, queryType, 10);
    console.log("RESULTS: ", results);
  };

  return (
    <Dialog
      title="Query Data Set"
      subtitle={dataSet?.name}
      show={show}
      onClose={onClose}
      onOK={handleQuery}
      okText="Submit"
      closeText="Close"
    >
      <ItalicSubTitle style={{ marginBottom: "20px" }}> {dataSet?.chroma_collection_name}</ItalicSubTitle>

      <FormElement style={{ marginBottom: "10px" }}>
        <FormLabel label="Query Type" />
        <FormSelector
          value={queryType ?? "similarity"}
          options={[
            { value: "similarity", label: "Similarity Search" },
            { value: "qa", label: "Question Answering" },
          ]}
          onChange={(e) => {
            console.log("Selected query type: ", e.target.value);
            setQueryType(e.target.value);
          }}
        />
      </FormElement>

      <FormElement>
        <FormLabel label="Query" />
        <FormInput
          as="textarea"
          rows={5}
          placeholder="Enter your query here"
          style={{ resize: "vertical" }}
          onChange={(e) => {
            setQuery(e.target.value);
          }}
        />
      </FormElement>
    </Dialog>
  );
};

export default QueryDialog;
